export const ALLOWANCE_INITIAL_STATE={
    "allowanceName": "",
    "allowanceType": "",
    "allowanceValue": "",
    "noWorkNoPay": "",
    "isEsiWages": false,
    "isEpfWages": false,
    "status":false,
}